<template>
  <div class="notice-container" @click="$emit('notice')">
    <div class="notice-box">
      <img class="notice-label" src="@images/templateD/notice.png" alt="" />

      <div class="scroll-viewport" ref="viewportRef">
        <div
          class="scroll-content"
          ref="contentRef"
          :style="{ transform: 'translateX(' + translateX + 'px)' }"
        >
          <span>{{ displayText }}</span>
          <span v-for="n in cloneCount" :key="n">{{ displayText }}</span>
        </div>
      </div>
    </div>
    <div class="mark"></div>
  </div>
</template>

<script>
export default {
  name: 'ScrollingNotice',
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      translateX: 0,
      animationId: null,
      cloneCount: 0,
      contentWidth: 0,
      viewportWidth: 0,
      speed: 1
    };
  },
  computed: {
    displayText () {
      return this.text || '';
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initScroll();
    });
  },
  beforeDestroy () {
    this.stopScroll();
  },
  methods: {
    initScroll () {
      const viewport = this.$refs.viewportRef;
      const content = this.$refs.contentRef;

      if (!viewport || !content) return;


      this.viewportWidth = viewport.clientWidth;

      this.contentWidth = content.scrollWidth;


      if (this.contentWidth <= this.viewportWidth) {
        this.cloneCount = 0;
        this.translateX = 0;
        return;
      }
      this.cloneCount = Math.ceil(this.viewportWidth / this.contentWidth) + 1;
      this.$nextTick(() => {
        this.startAnimation();
      });
    },

    startAnimation () {
      const animate = () => {
        this.translateX -= this.speed;
        if (Math.abs(this.translateX) >= this.contentWidth) {
          this.translateX = 0;
        }

        this.animationId = requestAnimationFrame(animate);
      };

      this.animationId = requestAnimationFrame(animate);
    },

    stopScroll () {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
    }
  }
};
</script>

<style scoped>
.notice-container {
  position: relative;
  width: 100%;
  margin-top: 0.41rem;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 0.2rem;
  border-radius: 0.43rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  box-sizing: border-box;
}

.notice-box {
  background-color: #ffffff;
  margin: 0 auto;
  border-radius: 0.13rem;
  height: 1.64rem;
  display: flex;
  align-items: center;
  padding: 0 0.43rem;
  overflow: hidden;
}
.notice-label {
  width: 3rem;
  padding-right: 0.2rem;
}

.scroll-viewport {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
}

.scroll-content {
  display: inline-block;
  will-change: transform;
  color: #1e293b;
  font-size: 14px;
}
.mark {
  width: 0.8rem;
  background: rgba(255, 255, 255, 0.7);
  height: 80%;
  position: absolute;
  top: 0.2rem;
  right: 0.2rem;
}
</style>